import { render, staticRenderFns } from "./KHGpy.vue?vue&type=template&id=00afefc2&scoped=true&"
import script from "./KHGpy.vue?vue&type=script&lang=js&"
export * from "./KHGpy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00afefc2",
  null
  
)

export default component.exports